import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import KeyCloakStudentSelectionLayout from './KeyCloakStudentSelectionLayout';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import { isEmpty } from '../../../library/Core/SmartFunctions';
import { axiosClient } from '../../../library/Service/axiosClient';
import SessionContext from '../../../library/Core/SessionContext';

const KeyCloakStudentSelection = ({pageTitle}:any) => {
    document.title=pageTitle;
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const navigate = useNavigate();
    const [students, setStudents] = useState<any[]>([]);
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            ROUTER_NAVIGATE: navigate,
        },
    } as any);

    const schoolDataLocalStorage = localStorage.getItem('school_settings');
    const schooldata = schoolDataLocalStorage ? JSON.parse(schoolDataLocalStorage) : {'domain': 'vibgyor'};
    const loginUrl = `${process.env.REACT_APP_APP_BASE_URL}/user/${schooldata.domain}/login`;

    useEffect(() => {
        setStudents(localStorage.getItem('studentData') ? JSON.parse(localStorage.getItem('studentData') ?? '{}') : []);
    },[]);

    const loginUser = async (student: any) => {
        const authResponse = await axiosClient().post(`${process.env.REACT_APP_STUDENT_SERVER}/v1/auth/authenticate-social-login`, {
                                registeredEmailId: student.registered_email_id
                            });

        if (!authResponse.data.token) {
            alert(authResponse.data.message);
            window.location.href = loginUrl;
            return;
        }

        const profileCount = authResponse?.data?.institutes?.filter((institute: any) => institute?.userStatusCode !== 'INACTIVE').length ?? 0;

        if (profileCount === 0) {
            alert("Your profile is not active, Please contact administrator..!");
            window.location.href = loginUrl;
            return;
        }

        sessionStorage.setItem('user', JSON.stringify(authResponse.data));
        sessionStorage.setItem('user-jwt-token', authResponse.data.token);

        localStorage.setItem('user', JSON.stringify(authResponse.data));
        localStorage.setItem('user-jwt-token', authResponse.data.token);
        localStorage.setItem('user-logged-out', 'FALSE');

        sessionDispatch({ type: 'SET', payload: authResponse.data.data });
        window.location.href = `${process.env.REACT_APP_APP_BASE_URL}/select-institute`;
    }    

    const handleSelection = (studentId: any) => {
        const selectedStudent = students.find((student: any) => student.id === studentId);
        if(!isEmpty(selectedStudent)){
            loginUser(selectedStudent);
        } else {
            alert('Selected student not found!');
        }
    };

    useEffect(() => {
        if (localStorage.getItem('matched') === '1' && students.length > 0) {
            handleSelection(students[0].id);
        }
    }, [students]);
    
    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <KeyCloakStudentSelectionLayout handleSelection={handleSelection} studentsLength={students?.length} studentData={students}>
            </KeyCloakStudentSelectionLayout>
            <DebugBarControl />
        </SmartContext.Provider>
    );
};

export default KeyCloakStudentSelection;
